import React, { Fragment, useEffect, useState } from "react";
import Message from "../../CommonData/Data/Message";
import { Button, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import VWLoading from "../../components/vwLoading/vwLoading";
import { connect } from "react-redux";
import { appVersionEdit, clearUpdateAppVersionError, setEditAppVersionForm } from "../../store/appVersion/actions";
import moment from "moment";

const EditAppVersion = (props) => {
    const { handleClose, errorMessage, appVersionetails, isPending, appVersionEditForm } = props;

    const [appVersion, setAppVersion] = useState("");

    useEffect(() => {
        if (appVersionetails) {
            setAppVersion({ ...appVersionetails });
            props.setEditAppVersionForm({
                formEditAppVersion: { ...appVersionetails },
                errors: {}
            })
        }
        props.clearUpdateAppVersionError();
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setAppVersion({ ...appVersion, [name]: value });

        props.setEditAppVersionForm({
            formEditAppVersion: {
                ...appVersionEditForm.formEditAppVersion,
                [name]: value
            },
            errors: {
                ...appVersionEditForm && appVersionEditForm.errors,
                [name]: null,
            }
        });
    }

    const handleEditAppVesrion = (e) => {
        e.preventDefault();
        const { formEditAppVersion } = appVersionEditForm || {};
        const { versionNo, releasedDate } = formEditAppVersion || {};
        const currentErrors = {};

        if (!versionNo) {
            currentErrors.versionNo = "Version no. is required"
        }

        if (!releasedDate) {
            currentErrors.releasedDate = "Release date is required"
        }

        props.setEditAppVersionForm({
            formEditAppVersion: {
                ...appVersionEditForm.formEditAppVersion,
            },
            errors: currentErrors,
        })

        if (Object.keys(currentErrors).length === 0) {
            props.appVersionEdit(appVersionEditForm.formEditAppVersion);
        }
    };

    return isPending ? (<VWLoading />) : (
        <Fragment>
            {errorMessage && (
                <Message type="danger" defaultMessage={errorMessage} baseClassName="alert" />
            )}
            <Form onSubmit={handleEditAppVesrion}>
                <FormGroup>
                    <Label>Version No.</Label><span className="text-danger">*</span>
                    <Input
                        autoFocus
                        type="text"
                        name="versionNo"
                        placeholder="Enter version no."
                        onChange={handleInputChange}
                        value={appVersion?.versionNo || ""}
                        invalid={appVersionEditForm && appVersionEditForm.errors && appVersionEditForm.errors.versionNo}
                    />
                    <FormFeedback>{appVersionEditForm && appVersionEditForm.errors && appVersionEditForm.errors.versionNo}</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label>Release Date</Label><span className="text-danger">*</span>
                    <Input
                        type="date"
                        name="releasedDate"
                        placeholder="Enter release date "
                        onChange={handleInputChange}
                        value={appVersion?.releasedDate ? moment(appVersion?.releasedDate).format("YYYY-MM-DD") : ""}
                        invalid={appVersionEditForm && appVersionEditForm.errors && appVersionEditForm.errors.releasedDate}
                    />
                    <FormFeedback>{appVersionEditForm && appVersionEditForm.errors && appVersionEditForm.errors.releasedDate}</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label>Notes</Label>
                    <Input
                        type="textarea"
                        name="notes"
                        placeholder="Enter notes"
                        onChange={handleInputChange}
                        value={appVersion?.notes || ""}
                    />
                </FormGroup>
                <FormGroup>
                    <Button
                        type="submit"
                        className='me-4'
                        color="success"
                        onClick={handleEditAppVesrion}
                    >
                        Update
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                </FormGroup>
            </Form>

        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    appVersionetails: state.appVersion.appVersionetails,
    appVersionEditForm: state.appVersion.appVersionEditForm,
    isPending: state.appVersion.isAppVersionEditPending,
    errorMessage: state.appVersion.appVersionEditErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    setEditAppVersionForm: (editAppVersionForm) => dispatch(setEditAppVersionForm(editAppVersionForm)),
    clearUpdateAppVersionError: () => dispatch(clearUpdateAppVersionError()),
    appVersionEdit: (editAppVersionForm) => dispatch(appVersionEdit(editAppVersionForm)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAppVersion);